import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';

export const ProductTable = ({ products, onEdit, onDelete }) => (
  <div className="bg-white rounded-lg shadow-md overflow-x-auto" data-testid="admin-products-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="bg-gray-50 text-left text-gray-500 uppercase text-xs">
          <th className="px-4 py-3">Product</th>
          <th className="px-4 py-3">Category</th>
          <th className="px-4 py-3">Price</th>
          <th className="px-4 py-3">Stock</th>
          <th className="px-4 py-3">Badges</th>
          <th className="px-4 py-3 text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {products.map((p) => (
          <tr key={p.id} className="border-t border-gray-100 hover:bg-gray-50">
            <td className="px-4 py-3">
              <div className="flex items-center gap-3">
                <img src={p.image} alt={p.name} className="w-10 h-10 rounded object-cover" />
                <span className="font-semibold text-[#001B2A]">{p.name}</span>
              </div>
            </td>
            <td className="px-4 py-3 text-gray-600">{p.category}</td>
            <td className="px-4 py-3 font-semibold">${p.price.toFixed(2)}</td>
            <td className="px-4 py-3">
              {typeof p.stock === 'number' ? (
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                  p.stock <= 0 ? 'bg-red-600 text-white' : p.stock <= 5 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                }`} data-testid={`stock-badge-${p.id}`}>
                  {p.stock <= 0 ? 'OUT' : p.stock}
                </span>
              ) : (
                <span className="text-xs text-gray-400">—</span>
              )}
            </td>
            <td className="px-4 py-3">
              <div className="flex gap-1">
                {p.isNew && <span className="bg-[#7B1E2B] text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">NEW</span>}
                {p.isBestSeller && <span className="bg-[#E6D7B3] text-[#001B2A] text-[10px] font-semibold px-2 py-0.5 rounded-full">BEST</span>}
              </div>
            </td>
            <td className="px-4 py-3">
              <div className="flex justify-end gap-2">
                <button data-testid={`edit-product-${p.id}`} onClick={() => onEdit(p)} className="p-2 text-gray-500 hover:text-[#001B2A] hover:bg-gray-100 rounded">
                  <Pencil className="h-4 w-4" />
                </button>
                <button data-testid={`delete-product-${p.id}`} onClick={() => onDelete(p)} className="p-2 text-red-500 hover:bg-red-50 rounded">
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
